import React from "react";
import { useForm } from "react-hook-form";
import { Button, TextAreaController } from "@pushpress/shared-components";
import PanelModal from "../PanelModal";

export interface SendTextForm {
  message: string;
}

export interface SendTextModalModalProps {
  title: string;
  message?: string;
  loading?: boolean;
  visible: boolean;
  onClose: VoidFunction;
  onSendClick: (values: SendTextForm) => void;
}

function SendTextModalModal(props: SendTextModalModalProps) {
  const { visible, onClose } = props;

  return (
    <PanelModal visible={visible} onClose={onClose}>
      <SendTextModalModalContent {...props} />
    </PanelModal>
  );
}

function SendTextModalModalContent(props: SendTextModalModalProps) {
  const { title, message, onSendClick, loading } = props;

  const { control, handleSubmit } = useForm<SendTextForm>();

  return (
    <form onSubmit={handleSubmit(onSendClick)}>
      <PanelModal.Header title={title} />
      <PanelModal.Body message={message}>
        <TextAreaController
          label="Message"
          control={control}
          name="message"
          required
          rows={9}
        />
      </PanelModal.Body>
      <PanelModal.Footer>
        <Button
          text="Send"
          buttonType="primary"
          loading={loading}
          type="submit"
        />
      </PanelModal.Footer>
    </form>
  );
}

export default SendTextModalModal;
